<script setup lang="ts">
export type Tab = {
    title: string;
    disabled?: boolean;
};
interface IProps {
    tabs?: Tab[];
    stickToHeaderInMobile?: boolean;
}
const { tabs = [], stickToHeaderInMobile } = defineProps<IProps>();
const modelValue = defineModel<number>({ default: 0 });
</script>

<template>
    <div
        class="tab-container-parent"
        :class="{ 'stick-to-header-in-mobile': stickToHeaderInMobile }"
    >
        <div class="tab-container">
            <div
                v-for="(tab, index) in tabs"
                :key="index"
                class="tab"
                :class="{
                    active: index === modelValue,
                    disabled: tab.disabled,
                }"
                @click="() => !tab.disabled && (modelValue = index)"
            >
                {{ tab.title }}
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.tab-container {
    display: flex;
}

.tab {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    color: usePalette($p-gray, $p-600);
    border-bottom: 1px solid usePalette($p-cool-gray);
    text-align: center;
    flex: 1;
    padding: 12px 0;
    cursor: pointer;
}

.active {
    color: usePalette();
    border-bottom: 3px solid usePalette();
}

.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

@media (max-width: $app-mobile-max-width) {
    .stick-to-header-in-mobile {
        height: 40px;
    }

    .stick-to-header-in-mobile .tab-container {
        position: absolute;
        top: 62px;
        right: 0;
        background: usePalette();
        width: 100%;
        height: 40px;
        z-index: 100;
    }

    .stick-to-header-in-mobile .tab {
        font-size: 14px;
        @include font-weight(bold);
        color: white;
        padding: 7px 0;
    }

    .stick-to-header-in-mobile .tab.active {
        border-bottom-width: 4px;
    }
}
</style>
